// THIS IS A GENERATED FILE, DO NOT EDIT
import { __assign } from "tslib";
import * as React from 'react';
import { Icon } from '../Icon';
var Upload = React.forwardRef(function Upload(props, ref) {
    return (React.createElement(Icon, __assign({}, props, { name: "Upload" }),
        React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "currentColor", xmlns: "http://www.w3.org/2000/svg", ref: ref },
            React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18 10.5C18.8333 6.5 15.3649 4 12.0446 4C8.90377 4 5.5 6 6 9.5C3 10.5 2 12.499 2 15C2 17.9618 4.41775 20 7.4002 20C7.46529 20 7.5301 19.9989 7.59462 19.9966H17.0086C17.0695 19.9989 17.1307 20 17.1921 20C19.8474 20 22 17.637 22 15C22 12.6472 20.2553 10.8942 18 10.5ZM16.5 13H13.5V17L10.5 17V13H7.5L12 8L16.5 13Z", fill: "currentColor" }))));
});
Upload.displayName = 'Upload';
export default Upload;
//# sourceMappingURL=Upload.js.map